<form
  #loginForm="ngForm"
  id="forms.loginForm"
  role="form"
  name="forms.loginForm"
  class="u_margin-sm-top"
  autocomplete="on"
  novalidate
>
  <div
    class="form-group"
    [ngClass]="{ 'has-error': loginForm.submitted && username.invalid }"
    show-errors
  >
    <label class="control-label" for="username">Work Email:</label>
    <div [shown]="disableUsername">{{ credentials.username }}</div>
    <input
      #username="ngModel"
      type="email"
      class="form-control"
      placeholder="example@email.com"
      id="username"
      name="username"
      [(ngModel)]="credentials.username"
      required
      focus-me="true"
      autocomplete="email"
      [shown]="!disableUsername"
      [pattern]="EMAIL_REGEX"
      (blur)="checkUsername()"
    />
    <p
      class="text-danger auth-form-error"
      [shown]="loginForm.submitted && username.invalid"
    >
      Please enter a valid email address in the format: example&#64;domain.com
    </p>
  </div>

  <password-input
    placeholder="{{ isSignUp ? 'Create a password' : '' }}"
    [shown]="passwordRequired && !invalidRequest"
    #password="ngModel"
    name="password"
    [(ngModel)]="credentials.password"
    label="Password:"
    [showPasswordMeter]="isSignUp"
    minlength="{{ isSignUp ? 8 : 0 }}"
    [required]="passwordRequired"
  >
  </password-input>

  @if (ssoEnabled && !usePassword) {
    <div class="my-5">
      <mat-icon
        class="check-icon"
        svgIcon="checkmark"
        aria-hidden="true"
      ></mat-icon>
      Single Sign-on is enabled for your account
    </div>
  }
  @if (!invalidRequest) {
    <button
      rv-button
      id="sign-in-button"
      class="tw-w-full"
      type="submit"
      form="forms.loginForm"
      (click)="submitForm.emit(loginForm)"
    >
      @if (isSignUp) {
        <span>{{ joinAccount ? 'Join' : 'Start My Free 14-Day Trial' }}</span>
      } @else {
        <span>{{
          passwordRequired
            ? 'Sign In'
            : 'Continue' +
              (ssoEnabled || provision ? ' with Single Sign-on' : '')
        }}</span>
      }
    </button>
  } @else {
    <button
      rv-button
      id="resend-email-button"
      class="tw-w-full tw-mt-2.5"
      type="button"
      (click)="handleInvalidRequest.emit()"
      [disabled]="username.invalid"
    >
      Resend Email
    </button>
  }

  @if (ssoEnabled) {
    <div class="my-4 text-center">
      <a rv-link actionLink (click)="alternateLogin()"
        >Continue with {{ usePassword ? 'Single Sign-on' : 'password' }}</a
      >
    </div>
  }
</form>

@if (!provision) {
  <rv-divider class="my-4" label="or" />

  <!-- GOOGLE API -->
  <button
    matButton="outlined"
    class="tw-w-full tw-mb-2.5 button-role--provider"
    type="button"
    id="sign-in-google-link"
    (click)="triggerGoogleLogin()"
  >
    <mat-icon svgIcon="integration-google" aria-hidden="true"></mat-icon>
    <span>{{ isSignUp ? 'Sign up' : 'Sign in' }} with Google</span>
  </button>
}
